export default {
  breadcrumb: {
    studies: '研究',
    newStudy: '新增研究',
  },
  hero: {
    step: '步驟 01',
    methodology: '方法論',
    title: '您想如何執行這項研究？',
    description:
      '每種方法都會決定後續設定的樣貌 — 您可以掃掠哪些參數、設計點如何取樣，以及執行會產生什麼。您之後可以變更此選擇，但後續流程會隨您的選擇而調整。',
  },
  comingSoon: '即將推出',
  methods: {
    doe: {
      title: '實驗設計法',
      subtitle: '執行每一種組合',
      description:
        '對您設定的每個離散值取笛卡兒積。每一種組合會成為一個 CFD 案例。當您已知哪些操作條件重要時最為適用。',
      bullet1: '離散＋清單參數',
      bullet2: '可預測的執行次數',
      bullet3: '結果表格＋掃掠圖表',
      diagramCaption: '笛卡兒網格 · n = 30',
    },
    surrogate: {
      title: '代理模型',
      subtitle: '訓練快速預測器',
      description:
        '在範圍內進行準隨機取樣，擬合可於毫秒內查詢的高斯過程代理模型。加入目標即可啟用多目標貝氏優化。',
      bullet1: '範圍參數',
      bullet2: 'GP 模型＋Pareto 前緣',
      bullet3: '自適應批次選取',
      diagramCaption: 'Sobol · n = 16 · GP 擬合',
    },
    gci: {
      title: '網格收斂指數',
      subtitle: '網格獨立性研究',
      description:
        '在粗、中、細三種網格上掃掠網格解析度；使用 Richardson 外插法估計離散化誤差，並回報網格收斂指數。',
      bullet1: '固定操作點',
      bullet2: '3 個網格細化層級',
      bullet3: '離散化誤差界限',
      diagramCaption: 'Richardson 外插法',
    },
  },
  footer: {
    selectingMethod: '選擇方法',
    rest: '即可建立草稿並開啟流程 — 診斷 · 網格 · 模擬 · 分析。已停用的方法已列入藍圖。',
    back: '返回',
    creating: '建立中',
    continue: '繼續',
  },
} as const;
